import { render, staticRenderFns } from "./IntegrationsPage.vue?vue&type=template&id=00dbbaa3&scoped=true&lang=html&"
import script from "./IntegrationsPage.vue?vue&type=script&lang=js&"
export * from "./IntegrationsPage.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsPage.vue?vue&type=style&index=0&id=00dbbaa3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dbbaa3",
  null
  
)

export default component.exports